import React from 'react'
import { Toolbar, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

function VisitToolbar({ title, button, onClose, classes }) {
  return (
    <Toolbar variant="dense">
      <IconButton
        autoFocus
        edge="start"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        size="large"
      >
        <CloseIcon />
      </IconButton>
      <Typography variant="h6" className={classes.title}>
        {title}
      </Typography>
      {button}
    </Toolbar>
  )
}

export default VisitToolbar
